<template>
  <div class="py-8 px-6 text-center text-sm">
    <p class="text-lg font-semibold text-gray-600">Nothing found</p>
    <p class="mt-2 text-gray-500">Try searching for something else <br/> or use commands like "product abc" or
      "order xyz"</p>
  </div>
</template>
